import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
    MDBCarouselInner,
    MDBCarouselItem } from 'mdbreact';

export default class History extends Component {
    constructor(props) {
        super(props);
        this.state = {
          emp:[],
        };
      //  this.handleChange = this.handleChange.bind(this);

      }

      componentDidMount() {

       
      }


  render() {
    return (
     
      <MDBContainer>
        <br/>
        <h2 className='text-center'>ประวัติโรงพยาบาลโกสัมพีนคร</h2>
        <img src="http://kosamphi.kpo.go.th/kosamphigo/kosamphibackend/uploadspic/1452.jpg" className="rounded mx-auto d-block w-10 " width="50%"   alt="aligment" /><br/>
        <h4>   โรงพยาบาลโกสัมพีนครเป็นโรงพยาบาลขนาด ๓๐ เตียง ก่อสร้างแล้วเสร็จเมื่อวันที่ ๒๐ กันยายน ๒๕๕๕ บนเนื้อที่ ๒๔ ไร่ ๒ งาน ๑๖ ตารางวา ตั้งอยู่บริเวณศูนย์ ราชการอำเภอโกสัมพีนคร เปิดให้บริการด้าน รักษาพยาบาล การส่งเสริมสุขภาพ การป้องกัน ควบคุมโรคและฟื้นฟูสภาพ ประกอบด้วยอาคารผู้ป่วยนอก ที่รองรับผู้ป่วย นอก ผู้ป่วยฉุกเฉิน ให้บริการแก่ประชาชนในเขตพื้นที่อำเภอโกสัมพีนคร และพื้นที่ใกล้เคียงจ านวน ๓๕,๐๐๐ คน โรงพยาบาลโกสัมพีนคร ได้เปิดให้บริการกับประชาชน เมื่อวันที่ ๑ สิงหาคม ๒๕๕๖ ในช่วงแรกจะเปิดให้บริการ ถึง ๒๐.๐๐ น. เพื่อให้บริการด้านการแพทย์และสาธารณสุขแก่ประชาชนในพื้นที่ ให้ได้รับบริการสาธารณสุขอย่างเท่าเทียมและ ทั่วถึงเกิดประโยชน์แก่ประชาชนสูงสุดเป็นไปตามนโยบายกระทรวงสาธารณสุขที่จะส่งเสริมให้ประชาชนมีคุณภาพชีวิตที่ดี ยิ่งขึ้น</h4>
</MDBContainer>
    )
  }
}
